<template>
    <page>
        <div class="shadow-25">
            <v-header :title="$t('upload and import file')" icon="cloud upload"></v-header>
            <card width="800px" style="margin: 0 auto;">

                <alert :trigger="success"
                       color="positive"
                       icon="done"
                       :html="responseMessage"></alert>

                <alert :trigger="success === false" v-for="( error,index ) in uploadErrors" :key="`error-${index}`"
                       color="negative"
                       icon="error">{{error}}</alert>

                <form @submit.prevent="upload"
                      class="q-pt-xs gutter-xs row">

                    <v-radio path="delimiter"
                             v-model="form.delimiter"
                             :label="$T('delimiter')"
                             :helper="$T('the character used to separate columns.')"
                             :options="delimiterOptions"
                             :form="form"
                             class="col-12">
                    </v-radio>

                    <v-select v-for="(column, i) in csvColumns"
                              :key="i"
                              :path="`column${i}`"
                              v-model="form[`column${i}`]"
                              :label="$_t('the column :i is the field', {i: i+1})"
                              :options="csvColumns"
                              :clearable="false"
                              :form="form"
                              class="col-12">
                    </v-select>

                    <!-- File -->
                    <v-file ref="file"
                            path="file"
                            :label="$t('select file')"
                            :url="url"
                            extensions=".csv"
                            color="highlight"
                            :helper="$T('save a csv file and upload it here.')"
                            @uploaded="receiveData"
                            :additional-fields="serializedForm"
                            :title="$T('select file')"
                            class="col-12">
                    </v-file>

                    <v-checkbox path="skip_first"
                                v-model="form.skip_first"
                                :label="$t('skip first line')"
                                :form="form"
                                class="col-12">
                    </v-checkbox>

                    <!-- Submit Button -->
                    <div class="row justify-center col-12 q-mt-md group">
                        <v-button outline
                                  :label="$t('Ver Información')"
                                  icon="info"
                                  color="info"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click.prevent="infoModalOpen('OrderImport')"
                                  type="button">
                        </v-button>
                        
                        <v-button outline
                                  :label="$t('download example')"
                                  icon="grid_on"
                                  color="info"
                                  class="no-shadow uppercase q-btn-iqos"
                                  @click.prevent="downloadSample('orders_to_import.csv')"
                                  type="button">
                        </v-button>

                        <v-button outline
                                  :label="$t('send')"
                                  icon="send"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  :loading="uploading"
                                  type="submit">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $t('sending...') | capitalize }}
                            </template>
                        </v-button>

                        <p v-if="uploading" class="col-12 q-mt-sm text-center text-negative">
                            {{ $T('the file will be processed after the upload.') }}
                            {{ $T('this could take a while until the imported data shows up in the list.') }}
                        </p>
                    </div>

                </form>

            </card>
        </div>

        <q-modal v-model="dragModal"
                 @drop.native.prevent.stop="onDrop"
                 @dragleave.native.prevent.stop="onDragLeave"
                 content-classes="row items-center justify-center upload-drop-zone">
            <h2 class="q-display-1 text-center">
                <q-icon name="cloud upload" color="faded" size="3em"></q-icon>
                <br>
                {{ $t('drop your file here') }}
            </h2>
        </q-modal>
        <q-modal v-model="infoModal" no-backdrop-dismiss no-esc-dismiss>
        <div>
            <v-header title="Guía de Importación" icon="info">
                <template slot="right">
                    <v-button flat rounded dense color="primary"
                              icon="close"
                              :label="$T('close')"
                              @click="infoModalClose"/>
                </template>
            </v-header>
            <card width="100%">
                <p>En esta tabla de relaciones podrás encontrar información necesaria para colocar en los excel de importación.</p>
                <div v-if="infoContent">
                    <div v-for="(items, category) in infoContent" :key="category">
                    <h3>{{ category }}</h3>
                    <table>
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Descripción</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.description || item.name }}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <p v-else>No data available</p>
            </card>
        </div>
        </q-modal>
    </page>
</template>

<script>
    import {
        QModal,
        QIcon,
        openURL
    } from 'quasar-framework'
    import { infoModalOpen, infoModalClose, fetchInfoContent } from '../../infoModalUtils';
    import Form from 'vform'

    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$T('upload and import file')}
        },

        components: {
            QModal,
            QIcon
        },

        data() {
            let csvColumns = [
                {label: this.$T('id'), value: 'id'},
                {label: this.$T('order finalization mode'), value: 'order_finalization_mode'}
            ]
            let delimiterOptions = [
                {label: this.$T('semicolon (;)'), value: ';'},
                {label: this.$T('comma (,)'), value: ','}
            ]
            let form = {
                skip_first: true,
                delimiter: ';'
            }

            csvColumns.forEach((column, i) => form[`column${i}`] = column.value)

            return {
                uploadErrors: [],
                uploader: {},
                dragModal: false,
                success: null,
                csvColumns,
                delimiterOptions,
                form: new Form(form),
                responseMessage: "",
                infoModal: false,
                infoContent: null,
            }
        },

        mounted() {
            this.uploader = this.$refs.file.$refs.uploader

            // Add listener for drag into the window
            window.addEventListener('dragover', this.onDragOver)
        },

        destroyed() {
            // Remove listener
            window.removeEventListener('dragover', this.onDragOver)
        },

        computed: {
            url() {
                return `${config.appUrl}/api/v1/order/import`
            },

            uploading() {
                return this.uploader.uploading
            },

            serializedForm() {
                return Object.keys(this.form).map(name => ({name, value: this.form[name]}))
            }
        },

        methods: {
            onDrop(e) {
                this.uploader.__onDrop(e)
                this.dragModal = false
            },

            onDragOver(e) {
                e.stopPropagation()
                e.preventDefault()
                this.dragModal = true
            },

            onDragLeave(e) {
                this.dragModal = false
            },

            upload() {
                //Resets the success state
                this.success = null

                // Submit the file
                this.uploader.upload()
            },

            receiveData(xhr) {
                // Get the response string (it's a common xhr request. The data is a string in response)
                var responseData = null

                // Tries to parse the data
                try {
                    responseData = JSON.parse(xhr.response)
                } catch (e) {

                }


                if (responseData && responseData.success) {
                    //Success (Triggers a positive alert)
                    this.success = true
                    this.responseMessage = responseData.success.message
                }
                // If no form data or formData, alert the user
                else {
                    if (responseData.error) {
                        this.$q.notify({
                            message: responseData.error.message,
                            type: 'negative',
                            icon: 'warning',
                            position: 'top',
                            timeout: 0,
                            closeBtn: true
                        })
                    } else {
                        if (responseData.errors) {
                            this.form.errors.errors = responseData.errors

                            responseData.errors.forEach(item => {

                                Object.values(item).forEach(error => {
                                    this.$q.notify({
                                        message: error[0],
                                        type: 'negative',
                                        icon: 'warning',
                                        position: 'top',
                                        closeBtn: true
                                    })
                                })
                            })

                        }

                        //Error (=not success. Triggers a negative alert)
                        this.success = false
                    }
                }

                // Clear the files object in the uploader (the reset method triggers some xhr unwanted behavior)
                this.uploader.files = []
            },

            downloadSample(fileName) {
                openURL(`${window.config.appUrl}/samples/${fileName}?v=h134566cbky72021`)
            },

            infoModalOpen,
            infoModalClose, 
            fetchInfoContent,
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/order/import.vue